import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../base/base.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { LoadingComponent } from '../../../shared/components/loader/loading/loading.component';

@Component({
   selector: 'app-layout-app',
   standalone: true,
   imports: [RouterOutlet, FooterComponent, LoadingComponent],
   templateUrl: './layout-app.component.html',
})
export class LayoutAppComponent extends BaseComponent {
   private router = inject(Router);
   showFooter = true;

   constructor() {
      super();
      this.updateFooter(this.router.url);
      this.router.events
         .pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            this.takeUntilDestroy(),
         )
         .subscribe((event) => this.updateFooter(event.urlAfterRedirects));
   }

   private updateFooter(url: string): void {
      const path = url.split('?')[0].toLowerCase();
      this.showFooter = !/(?:\/empresas(?:\/|$)|\/perfil\/)/.test(path);
   }
}
